export default "__VITE_ASSET__BSoNv$2d__"